import { DEFAULT_STORE_OBJECT, DEFAULT_THEME_DATA } from '../../contants/common';
import SettingsTypes from './SettingsTypes';

const initialState = {
  tmsSettings: { ...DEFAULT_STORE_OBJECT, data: {} },
  saveTmsSettings: { ...DEFAULT_STORE_OBJECT },
  userThemes: {
    ...DEFAULT_STORE_OBJECT,
    data: DEFAULT_THEME_DATA,
  },
};

const SettingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SettingsTypes.GET_TMS_SETTINGS_PROGRESS: {
      return {
        ...state,
        tmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: {},
          ...payload,
        },
      };
    }

    case SettingsTypes.GET_TMS_SETTINGS_SUCCESS: {
      return {
        ...state,
        tmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.GET_TMS_SETTINGS_ERROR: {
      return {
        ...state,
        tmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          data: {},
          error: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.SAVE_TMS_SETTINGS_PROGRESS: {
      return {
        ...state,
        saveTmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.SAVE_TMS_SETTINGS_SUCCESS: {
      return {
        ...state,
        saveTmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.SAVE_TMS_SETTINGS_ERROR: {
      return {
        ...state,
        saveTmsSettings: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.GET_USER_THEMES_PROGRESS: {
      return {
        ...state,
        userThemes: {
          ...DEFAULT_STORE_OBJECT,
          progressing: true,
          data: state?.userThemes?.data,
        },
      };
    }
    case SettingsTypes.GET_USER_THEMES_SUCCESS: {
      return {
        ...state,
        userThemes: {
          ...DEFAULT_STORE_OBJECT,
          success: true,
          data: { ...state?.userThemes?.data, ...payload?.data },
        },
      };
    }
    case SettingsTypes.GET_USER_THEMES_ERROR: {
      return {
        ...state,
        userThemes: {
          ...DEFAULT_STORE_OBJECT,
          error: true,
          ...payload,
        },
      };
    }

    case SettingsTypes.SET_USER_THEMES: {
      return {
        ...state,
        userThemes: {
          ...DEFAULT_STORE_OBJECT,
          ...payload,
        },
      };
    }

    default:
      return state;
  }
};

export default SettingsReducer;
